import { render } from "./about-us.vue?vue&type=template&id=71b06587&scoped=true"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"

import "./about-us.vue?vue&type=style&index=0&id=71b06587&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b06587"]])

export default __exports__